import { createArrayIntentType } from '../intent';
export const runtimeStyleIntent = createArrayIntentType('StyleIntent', (decorate)=>(styles)=>decorate(styles));
export const lazyStyleIntent = createArrayIntentType('LazyStyleIntent', (decorate)=>(...args)=>// Need to force cast to Style.Intent because the
        // compiled styles type is missing from the args array.
        // This is safe to do because the second parameter is not
        // exposed to users but it's being added by the Sail X babel plugin.
        decorate(args));
export const lazyGlobalStyleIntent = createArrayIntentType('LazyGlobalStyleIntent', (decorate)=>(styles)=>decorate(styles));

//# sourceMappingURL=intents.js.map